import React from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import person1 from "../../Assets/Images/person1.png";
import person2 from "../../Assets/Images/person2.png";
import person3 from "../../Assets/Images/person3.png";

import person4 from "../../Assets/Images/person4.png";
import { FaArrowRight } from "react-icons/fa6";

export const HomeBanner = () => {
  return (
    <div className="container-fluid home-banner">
      <div className="home-banner-content ">
        <h2>
          We help you achieve International <br /> certification faster & easier
        </h2>
        <p>
          Our experts guide you through every step of the certification process,
          saving you time and effort. Get compliant with confidence, backed by
          proven results and industry know-how.
        </p>

        <div className="d-flex gap-3">
          <AvatarGroup max={4}>
            <Avatar alt="Remy Sharp" src={person1} />
            <Avatar alt="Travis Howard" src={person2} />
            <Avatar alt="Cindy Baker" src={person3} />
            <Avatar alt="Agnes Walker" src={person4} />
            <Avatar alt="Trevor Henderson" src={person1} />
          </AvatarGroup>
          <p>10k + Happy Customers</p>
        </div>
        <button
          className="btn btn-outline-light rounded-pill px-4 mt-3"
        >
           Get started
        </button>
      </div>
    </div>
  );
};
